import { useTranslation } from "@resamare/translation";
import { FormBuilder, Spinner, Stack, Step } from "@resamare/ui";
import { forwardRef } from "react";
import { SubmitHandler } from "react-hook-form";
import { Liaison } from "../../../../models";
import { useGetSessionOptionsForm } from "../../../sessions";
import { useNavibusQueryParams } from "../hooks/useNavibusQueryParams";
import { toRefObject } from "../utils/toRefObject";

type NavibusOptionsContainerProps = {
    liaison: Liaison;
    onSubmit: SubmitHandler<Record<string, number>>;
    step: number | null;
};

export const NavibusOptionsContainer = forwardRef<HTMLFormElement, NavibusOptionsContainerProps>(
    ({ liaison, onSubmit, step }, ref) => {
        const { t } = useTranslation();

        const { validQuery } = useNavibusQueryParams();
        const optionsQuery = useGetSessionOptionsForm(liaison.id, {
            participants: validQuery.participants,
        });

        const stepTitle = `${liaison.lieux_depart[0].label} -> ${liaison.lieux_destination[0].label}`;

        if (optionsQuery.isPending) return <Spinner />;

        return (
            <Stack gap={3}>
                {step ? (
                    <Step
                        direction="row"
                        gap={1}
                        step={step}
                        subtitle={`${t("Étape")} ${step}`}
                        title={stepTitle}
                    />
                ) : null}
                {optionsQuery.data ? (
                    <FormBuilder
                        data={optionsQuery.data}
                        formRef={toRefObject(ref)}
                        onSubmit={onSubmit}
                    />
                ) : null}
            </Stack>
        );
    },
);

NavibusOptionsContainer.displayName = "NavibusOptionsContainer";
